/** The Waiting on you piece, standard look over its behavior half. */
import type { PieceInput } from '../../contract/runtime';
import type { WaitingOnYouEvents } from './contract';
import { WaitingOnYouView } from './WaitingOnYouView';
import { useWaitingOnYou } from './useWaitingOnYou';

export { WaitingOnYouView, useWaitingOnYou };

export function WaitingOnYou(props: PieceInput<WaitingOnYouEvents>) {
  return <WaitingOnYouView {...useWaitingOnYou(props)} />;
}
